import './Image.css';

export const Image = (props) => (
  <div className={'Image unselectable ' + (props.className || '')}>
    <img className="undraggable" src={props.src} alt={props.alt || ''}/>
  </div>
);

export default Image;
